var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import React, { PureComponent } from 'react';
import PatientTermCardAPI from './patient-term-card-api';
import { ReactComponent as CancelSVG } from '../../assets/images/icons/cancel.svg';
import { ReactComponent as CheckSVG } from '../../assets/images/icons/check.svg';
import './patient-term-card.css';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { generateUUID, trigger } from '@philips-internal/oswald-ui-utils';
import { Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
let PatientTermCard = class PatientTermCard extends PureComponent {
    static { this.propTypes = {
        dtConfirmacao: string,
        nrSeqTermo: number,
        onClick: eventListener,
        status: string,
        termo: string,
    }; }
    renderHeader() {
        const { dtConfirmacao } = this.props;
        return (React.createElement("div", { className: 'c-patient-term-card__header' },
            React.createElement("div", { className: 'c-patient-term-card__header-left' }, ModelService.format('date', dtConfirmacao))));
    }
    renderContent() {
        const { termo } = this.props;
        return (React.createElement("div", { className: 'c-patient-term-card__content' }, termo));
    }
    renderFooter() {
        const { status } = this.props;
        const msgStatus = status ? MessageService.translate('patient.term-card.status-' + status.toLowerCase()) : '';
        return (React.createElement("div", { className: 'c-patient-term-card__footer' },
            React.createElement("div", { className: 'c-patient-cpt-card__footer-left' },
                this.getSvg(),
                '\u00A0',
                msgStatus)));
    }
    render() {
        const { onClick } = this.props;
        return (React.createElement(Card, { uuid: generateUUID(), onClick: trigger(onClick, new ClickEvent()), width: 12, className: 'c-patient-term-card', selectionType: SelectionType.NONE },
            React.createElement("div", { className: `c-patient-term-card__wrapper c-patient-term-card__border-${this.getColor()}` },
                this.renderContent(),
                this.renderHeader(),
                this.renderFooter())));
    }
    getColor() {
        const { status } = this.props;
        switch (status) {
            case 'I':
                return 'gray';
            case 'A':
                return 'green';
            default:
                return 'gray';
        }
    }
    getSvg() {
        const { status } = this.props;
        switch (status) {
            case 'I':
                return React.createElement(CancelSVG, { className: `c-patient-term-card__color-${this.getColor()}` });
            case 'A':
                return React.createElement(CheckSVG, { className: `c-patient-term-card__color-${this.getColor()}` });
            default:
                return React.createElement(React.Fragment, null);
        }
    }
};
PatientTermCard = __decorate([
    AwesomeComponent({ api: PatientTermCardAPI, type: ComponentType.DATA_DISPLAY })
], PatientTermCard);
export default PatientTermCard;
//# sourceMappingURL=patient-term-card.js.map